import { useLocale } from '@/i18n/useLocale';
import { useLingui } from '@lingui/react';
import { type UseListStateHandlers, useListState } from '@mantine/hooks';
import { usePathname } from 'next/navigation';
import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
export type SVGIconProps = {
  blurHeight: number;
  blurWidth: number;
  height: number;
  src: string;
  width: number;
};
export type NavbarDataProps = {
  icon?: React.ReactNode;
  label: string | 'SEPARATOR';
  active: boolean;
  href?: string;
  onClick?: () => void;
  items?: NavbarDataProps[];
};
export type NavbarDataType = {
  values: NavbarDataProps[];
  handlers: UseListStateHandlers<NavbarDataProps>;
  handleItemClick: (path: string) => void;
};
export const setActiveItem = <T extends NavbarDataProps,>(handlers: UseListStateHandlers<T>, path: string) => handlers.setState(current => {
  return current.map(item => {
    if (item.href === path && item.items?.length) {
      return {
        ...item,
        active: !item.active
      };
    }
    if (item.href === path) {
      return {
        ...item,
        active: true
      };
    }
    return {
      ...item,
      active: false
    };
  });
});
export const useNavbarItems = (): NavbarDataType => {
  const {
    i18n
  } = useLingui();
  const {
    path
  } = useLocale();
  const pathname = usePathname();
  const {
    setOpenModal
  } = useModalAction();
  const [values, handlers] = useListState([{
    icon: <Icons className="icon-pr-flat-playing-cards" fontSize={30} color="var(--icon-color)" />,
    label: i18n._('Casino'),
    href: `${path}/casino`,
    active: pathname.startsWith(`${path}/casino`),
    items: [{
      label: i18n._('Primeroll Original'),
      href: `${path}/casino/primeroll`,
      active: pathname.startsWith(`${path}/casino/primeroll`)
    }, {
      label: i18n._('Slots'),
      href: `${path}/casino/slots`,
      active: pathname.startsWith(`${path}/casino/slots`)
    }, {
      label: i18n._('Game Shows'),
      href: `${path}/casino/gameshows`,
      active: pathname.startsWith(`${path}/casino/gameshows`)
    }, {
      label: i18n._('Live Casino'),
      href: `${path}/casino/live`,
      active: pathname.startsWith(`${path}/casino/live`)
    }, {
      label: i18n._('Roulette'),
      href: `${path}/casino/roulette`,
      active: pathname.startsWith(`${path}/casino/roulette`)
    }, {
      label: i18n._('Blackjack'),
      href: `${path}/casino/blackjack`,
      active: pathname.startsWith(`${path}/casino/balckjack`)
    }]
  }, {
    icon: <Icons className="icon-pr-flat-cat" fontSize={30} color="var(--icon-color)" />,
    label: i18n._('Primeorbs'),
    href: `${path}/primeorbs`,
    active: pathname.startsWith(`${path}/primeorbs`),
    items: [{
      label: i18n._('Bunker'),
      onClick: () => setOpenModal(MODAL.BUNKER),
      href: `${path}/primeorbs/bunker`,
      active: pathname.startsWith(`${path}/primeorbs/bunker`)
    }, {
      label: i18n._('Marketplace'),
      href: `${path}/primeorbs/marketplace`,
      active: pathname.startsWith(`${path}/primeorbs/marketplace`)
    }]
  }, {
    icon: <Icons className="icon-pr-flat-features" fontSize={30} color="var(--icon-color)" />,
    label: i18n._('Lootboxes'),
    href: `${path}/lootboxes`,
    active: pathname.startsWith(`${path}/lootboxes`)
  }, {
    icon: <Icons className="icon-pr-flat-vs" fontSize={30} color="var(--icon-color)" />,
    label: i18n._('Battles'),
    href: `${path}/battles`,
    active: pathname.startsWith(`${path}/battles`)
  }, {
    icon: <Icons className="icon-pr-flat-swords" fontSize={30} color="var(--icon-color)" />,
    label: i18n._('Challenges'),
    href: `${path}/challenges`,
    active: pathname.startsWith(`${path}/challenges`)
  }, {
    label: 'SEPARATOR',
    active: false
  }, {
    icon: <Icons className="icon-pr-flat-vip-crown" fontSize={30} color="var(--icon-color)" />,
    label: i18n._('VIP Club'),
    href: `${path}/vip-club`,
    active: pathname.startsWith(`${path}/vipclub`)
  }, {
    icon: <Icons className="icon-pr-flat-affiliate" fontSize={30} color="var(--icon-color)" />,
    label: i18n._('Affiliate'),
    href: `${path}/affiliate`,
    active: pathname.startsWith(`${path}/affiliate`)
  }, {
    icon: <Icons className="icon-pr-flat-chat" fontSize={30} color="var(--icon-color)" />,
    label: i18n._('Live Support'),
    href: `${path}/support`,
    active: pathname.startsWith(`${path}/support`)
  }, {
    icon: <Icons className="icon-pr-flat-blog" fontSize={30} color="var(--icon-color)" />,
    label: i18n._('Blog'),
    href: `${path}/blog`,
    active: pathname.startsWith(`${path}/blog`),
    items: [{
      label: i18n._('News'),
      href: `${path}/blog/news`,
      active: pathname.startsWith(`${path}/blog/news`)
    }, {
      label: i18n._('Promotions'),
      href: `${path}/blog/promotions`,
      active: pathname.startsWith(`${path}/blog/promotions`)
    }, {
      label: i18n._('Tutorials'),
      href: `${path}/blog/tutorials`,
      active: pathname.startsWith(`${path}/blog/tutorials`)
    }]
  }]);
  return {
    values,
    handlers: handlers as UseListStateHandlers<NavbarDataProps>,
    handleItemClick: (path: string) => setActiveItem(handlers, path)
  };
};

// export const useResourcesNavbarItems = (): NavbarDataType => {
// 	const { i18n } = useLingui()
// 	const { path } = useLocale()
// 	const pathname = usePathname()
// 	const [values, handlers] = useListState([
// 		{
// 			icon: (
// 				<Icons
// 					className="icon-pr-flat-vip-crown"
// 					fontSize={30}
// 					color="var(--icon-color)"
// 				/>
// 			),
// 			label: i18n._('VIP Club'),
// 			href: `${path}/vipclub`,
// 			active: pathname.startsWith(`${path}/vipclub`),
// 		},
// 		{
// 			icon: (
// 				<Icons
// 					className="icon-pr-flat-affiliate"
// 					fontSize={30}
// 					color="var(--icon-color)"
// 				/>
// 			),
// 			label: i18n._('Affiliate'),
// 			href: `${path}/affiliate`,
// 			active: pathname.startsWith(`${path}/affiliate`),
// 		},
// 		{
// 			icon: (
// 				<Icons
// 					className="icon-pr-flat-chat"
// 					fontSize={30}
// 					color="var(--icon-color)"
// 				/>
// 			),
// 			label: i18n._('Live Support'),
// 			href: `${path}/support`,
// 			active: pathname.startsWith(`${path}/support`),
// 		},
// 		{
// 			icon: (
// 				<Icons
// 					className="icon-pr-flat-blog"
// 					fontSize={30}
// 					color="var(--icon-color)"
// 				/>
// 			),
// 			label: i18n._('Blog'),
// 			href: `${path}/blog`,
// 			active: pathname.startsWith(`${path}/blog`),
// 			items: [
// 				{
// 					label: i18n._('News'),
// 					href: `${path}/blog/news`,
// 					active: pathname.startsWith(`${path}/blog/news`),
// 				},
// 				{
// 					label: i18n._('Promotions'),
// 					href: `${path}/blog/promotions`,
// 					active: pathname.startsWith(`${path}/blog/promotions`),
// 				},
// 				{
// 					label: i18n._('Tutorials'),
// 					href: `${path}/blog/tutorials`,
// 					active: pathname.startsWith(`${path}/blog/tutorials`),
// 				},
// 			],
// 		},
// 	])

// 	return {
// 		values,
// 		handlers: handlers as UseListStateHandlers<NavbarDataProps>,
// 		handleItemClick: (path: string) => setActiveItem(handlers, path),
// 	}
// }